var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-ring",style:(_vm.styles.wrapper)},[_c('div',{style:(_vm.styles.ring)}),_c('div',{style:(_vm.styles.ring)}),_c('div',{style:(_vm.styles.ring)}),_c('div',{style:(_vm.styles.ring)})])}
var staticRenderFns = []

export { render, staticRenderFns }